var _circle, _path, _circle2, _path2, _path3, _circle3, _path4, _path5, _circle4, _path6, _path7, _circle5, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecreation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 15.2501,
    r: 4.1451,
    stroke: "#EE2F4B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.37427V9.03231",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 15.2501,
    r: 4.1451,
    stroke: "#EE2F4B",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.37427V9.03231",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21.4678V23.1258",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15.25,
    r: 4.1451,
    transform: "rotate(45 15 15.25)",
    stroke: "#EE2F4B",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5688 9.68115L19.3964 10.8536",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.603 19.6465L9.43061 20.8189",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9999,
    cy: 15.2501,
    r: 4.1451,
    transform: "rotate(90 14.9999 15.2501)",
    stroke: "#EE2F4B",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8755 15.2502L21.2174 15.2502",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78223 15.2502L7.12418 15.2502",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0002,
    cy: 15.25,
    r: 4.1451,
    transform: "rotate(135 15.0002 15.25)",
    stroke: "#EE2F4B",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5688 20.8191L19.3964 19.6467",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6035 10.8535L9.4311 9.6811",
    stroke: "#EE2F4B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecreation);
export default __webpack_public_path__ + "static/media/Recreation.bd31bfd652f51065b2839159abcf3a7b.svg";
export { ForwardRef as ReactComponent };